import { render, staticRenderFns } from "./MRDetail.vue?vue&type=template&id=0013acda"
import script from "./MRDetail.vue?vue&type=script&lang=ts"
export * from "./MRDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports